import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AutoComplete } from '@spark';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';
import { HELP_TEXTS } from '@/features/datasets/components/DataCollection/GenerateDataWithAI/constants';
import {
    catalogLabelNames,
    NO_PREDICTIONS_GENERATION_TARGET,
} from '@/features/datasets/components/DataCollection/GenerateDataWithAI/useGenerationTargets';

/**
 * Multi-select of the task's real labels (Spark AutoComplete, same pattern as
 * Supported languages). An empty selection means No predictions.
 */
const ExampleLabelsField = ({ options, value, onChange }) => {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const selected = Array.isArray(value) ? value : [];
    const labelOptions = catalogLabelNames(options);

    const handleOpenChange = (next) => {
        setOpen(next);
        if (!next) setQuery('');
    };

    const toggle = (name) => {
        if (!name) return;
        onChange(selected.includes(name) ? selected.filter((label) => label !== name) : [...selected, name]);
    };

    return (
        <div className="gdai-field gdai-example-row__labels">
            <FieldLabel text="Labels" help={HELP_TEXTS.exampleLabels} />
            <div onClick={() => setOpen(true)} onFocus={() => setOpen(true)}>
                <AutoComplete
                    className="spark-select-full-width gdai-example-labels"
                    type="multi-select"
                    size="medium"
                    placeholder={selected.length ? 'Search' : NO_PREDICTIONS_GENERATION_TARGET}
                    open={open}
                    onOpenChange={handleOpenChange}
                    value={query}
                    tags={selected}
                    items={labelOptions.map((name) => ({
                        label: name,
                        checked: selected.includes(name),
                        onClick: () => toggle(name),
                    }))}
                    onChange={(event) => setQuery(event.target.value)}
                    onTagRemove={(_tag, index) => onChange(selected.filter((_, itemIndex) => itemIndex !== index))}
                />
            </div>
        </div>
    );
};

ExampleLabelsField.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
};

export default ExampleLabelsField;
